import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeScheduleBListItem extends SearchModelBase {
    code: string = '';
    sdescription: string = '';
    unit1: string = '';
    unit2: string = '';
    cid: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Schedule B', width: 100, dataIndex: 'code'}),
        XCol.Create({ col: 1, text: 'Description', width: 500, dataIndex: 'sdescription'}),
        XCol.Create({ col: 2, text: 'Unit 1', width: 70, dataIndex: 'unit1'}),
        XCol.Create({ col: 3, text: 'Unit 2', width: 70, dataIndex: 'unit2'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeScheduleBListItem.prototype.code, orderByAscending: true };

    public static formatData(data: CodeScheduleBListItem[]) {
        return data.map((d: CodeScheduleBListItem) => ({
          ...d,
        }));
    }

}
